var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C40.8224 16 48 23.1776 48 32C48 40.8224 40.8224 48 32 48C23.1776 48 16 40.8224 16 32C16 23.1776 23.1776 16 32 16ZM38.6448 35.2256C34.7936 37.9776 29.208 37.9776 25.3552 35.2256L23.496 37.8304C25.968 39.5952 28.9088 40.528 32 40.528C35.0912 40.528 38.032 39.5952 40.504 37.8304L38.6448 35.2256ZM38.4 26.4C37.0752 26.4 36 27.4752 36 28.8C36 30.1248 37.0752 31.2 38.4 31.2C39.7248 31.2 40.8 30.1248 40.8 28.8C40.8 27.4752 39.7248 26.4 38.4 26.4ZM25.6 26.4C24.2752 26.4 23.2 27.4752 23.2 28.8C23.2 30.1248 24.2752 31.2 25.6 31.2C26.9248 31.2 28 30.1248 28 28.8C28 27.4752 26.9248 26.4 25.6 26.4Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.9a8e7d3fe369722190ba3a73982d4278.svg";
export { ForwardRef as ReactComponent };